// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';

export const resetExportToExcelLayout = () => ({
    type: actions.RESET_EXPORT_TO_EXCEL_LAYOUT
});



// WEBPACK FOOTER //
// ./src/shared/action-creators/reset-export-to-excel-layout.js